import React, { useCallback, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Select, { createFilter } from 'react-select'
import { selectCategories } from '../../selectors/categoriesSelector'
import { push } from 'react-router-redux'
import municipalities from '../../static/municipalities'
import './municipalitySearchBox.pcss'

const selectStyles = {
  control: (styles) => ({
    ...styles,
    color: '#000000',
    backgroundColor: '#FAFAFA',
    fontSize: '16px',
    width: '170px',
  }),
  option: (styles) => ({ ...styles, color: '#000000' }),
  noOptionsMessage: (styles) => ({
    ...styles,
    color: '#000000',
    fontSize: '14px',
  }),
  dropdownIndicator: () => ({ display: 'none' }),
  indicatorSeparator: () => ({ display: 'none' }),
}

/**
 * Renders a searchable select for municipalities and tries to find a
 * category with a matching name.
 *
 * Match is first attempted with "name" and if that produces no results, with "parent".
 * If a match is found, redirects user to that category.
 */

export default function MunicipalitySearchBox() {
  const dispatch = useDispatch()
  const categories = useSelector(selectCategories)
  const selectRef = useRef(null)
  const [inputValue, setInputValue] = useState('')

  const lookupCategoryByName = useCallback((validSelection) => {
    const match = (name) => categories.find((cat) => cat.get('name').toLowerCase() === name.toLowerCase())
    return match(validSelection.label)
      || (validSelection.parent && match(validSelection.parent))
      || null
  }, [categories])

  const handleChange = useCallback((option) => {
    if (!option) return
    const category = lookupCategoryByName(option)
    if (!category) return
    dispatch(push(`/${category.get('slug')}`))
  }, [lookupCategoryByName, dispatch])

  const handleSubmit = (e) => {
    e.preventDefault()
    // react-select internal state; not public API — verify on upgrades
    const focusedOption = selectRef.current?.state?.focusedOption
    if (focusedOption) {
      handleChange(focusedOption)
      selectRef.current.clearValue()
      selectRef.current.blur()
    }
  }

  // value={null} means the selection is always immediately cleared after selection
  return (
    <section className='municipality-search search-province-news'>
      <div className='municipality-search-header'>Etsi kuntasi uutiset</div>
      <div className='municipality-search-content'>
        <Select
          ref={ selectRef }
          value={ null }
          options={ municipalities }
          getOptionValue={ (opt) => opt.label }
          filterOption={ createFilter({ matchFrom: 'start', ignoreAccents: false }) }
          onChange={ handleChange }
          onInputChange={ setInputValue }
          placeholder='Syötä kunta'
          noOptionsMessage={ () => '❗Haulla ei löydy uutisia' }
          menuIsOpen={ inputValue.length > 0 }
          styles={ selectStyles }
        />
        <button className='button button_slim button_overlap-left' type='button' onMouseDown={ handleSubmit }>Etsi</button>
      </div>
    </section>
  )
}
